var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 574,
    height: 235,
    viewBox: "0 0 574 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.155 182.21H420.979L272.296 142.371",
    fill: "#131527"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M398.468 230.402H517.609L533.629 234.692H559.508L542.148 230.043H573.276L411.421 186.675",
    fill: "#131527"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4922 149.752H216.633L232.654 154.042H258.532L241.172 149.393H272.3L110.445 106.025",
    fill: "#131527"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3232 85.4136L100.296 101.072V129.418L136.193 139.733V112.318L152.16 116.958V88.4502L136.193 84.9165V9.83374L101.021 0.495422L41.3232 55.8803V85.4226V85.4136ZM100.296 35.6048V73.6567L69.8129 65.5635L100.296 35.6048Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.02,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1348 11.4416C60.1348 11.4416 63.149 8.66924 67.8159 9.38137C72.4828 10.098 76.7064 4.31584 82.1078 4.96079C87.5092 5.60574 88.7946 1.35088 93.9542 1.78532C99.1138 2.21976 101.188 0.437195 101.188 0.437195L136.207 9.8203L128.835 22.1997L104.703 24.3585L99.5796 22.9835L103.575 20.2738L95.0605 20.8426L60.1348 11.4327V11.4416Z",
    fill: "url(#paint0_linear_743_1487)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4557 71.8159C32.4557 71.8159 25.5808 73.697 26.5079 76.55C27.435 79.403 24.1341 82.3994 32.4557 83.6131C40.7773 84.8269 43.3974 86.605 50.1112 86.1795C56.8249 85.754 60.1661 88.0113 62.4189 84.7776C64.6718 81.5439 67.3277 81.3289 66.535 74.4808C65.7422 67.6327 66.1811 65.035 63.9641 63.3734C61.7471 61.7118 61.035 61.5013 61.035 61.5013",
    fill: "url(#paint1_linear_743_1487)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7831 76.5904C28.7831 76.5904 30.6284 75.0273 33.5575 75.3094C36.4911 75.5916 38.2065 76.8188 41.3327 73.7911C44.4634 70.7634 47.9479 70.2752 50.8636 70.6739C53.7794 71.068 61.7695 68.7211 63.0281 64.5648C64.2866 60.4084 65.2944 45.1715 63.8925 44.5758C62.4906 43.9802 51.6877 41.0152 45.6279 45.0954C39.5636 49.1756 24.0401 62.5224 20.9766 65.5546",
    fill: "url(#paint2_linear_743_1487)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0605 20.9904C95.0605 20.9904 101.049 18.3435 105.639 19.2258C110.23 20.1081 113.271 18.8182 115.636 17.0491C117.997 15.28 123.322 12.0552 127.604 12.9331C131.885 13.8109 136.207 9.82477 136.207 9.82477V88.8309L95.0605 96.2344V20.9949V20.9904Z",
    fill: "url(#paint3_linear_743_1487)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0605 149.976C95.0605 149.976 100.811 151.328 104.041 148.354C107.274 145.38 108.69 144.279 113.316 144.426C117.943 144.574 119.331 144.91 124.012 143.002C128.692 141.094 130.922 139.706 132.597 139.916C134.268 140.127 136.207 139.733 136.207 139.733V116.765L95.0605 123.291V149.971V149.976Z",
    fill: "url(#paint4_linear_743_1487)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.121 127.599C111.121 127.599 115.206 125.468 118.471 125.629C121.736 125.795 122.618 127.492 126.47 126.296C130.322 125.105 129.905 121.163 135.884 120.962C141.864 120.76 145.868 122.019 147.91 120.55C149.952 119.085 152.178 116.944 152.178 116.944V88.4458L138.903 88.1009L111.121 97.475V127.595V127.599Z",
    fill: "#A807AA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M226.737 38.1129C233.72 37.2441 241.379 38.0278 249.261 40.1195C282.472 48.9382 304.592 76.2097 304.592 117.63C304.592 144.229 296.79 166.068 275.57 170.816L275.561 170.851C275.561 170.851 271.575 172.988 266.102 173.386C260.628 173.785 261.47 176.074 253.839 176.674C246.207 177.274 243.502 182.335 234.356 181.896C225.206 181.457 199.936 161.679 197.647 161.621C195.359 161.562 179.249 163.726 178.536 144.861L176.212 51.2582C176.212 51.2582 182.164 46.0673 191.83 46.3898C201.495 46.7123 197.235 43.2994 206.327 43.1874C215.366 43.0755 212.871 37.8756 226.737 38.1174V38.1129Z",
    fill: "url(#paint5_linear_743_1487)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M246.188 39.367C247.205 39.5954 248.231 39.8462 249.261 40.1194C251.021 40.5852 252.745 41.1048 254.438 41.6736C254.353 42.7395 254.685 43.801 255.997 44.5893C260.561 47.3303 272.443 51.0343 272.864 57.2867C273.178 61.9312 267.642 62.2 265.071 64.9455C260.995 69.3033 270.213 70.5753 269.156 73.6612C268.224 76.3933 261.179 74.4764 259.249 74.4764C257.157 74.4764 256.1 77.8803 253.95 77.2353C252.289 76.7382 252.127 69.1376 250.551 69.5407C243.071 71.4621 247.344 77.4189 245.1 79.0716C242.713 80.8318 238.467 81.0513 235.645 81.5215C227.875 82.8159 221.112 82.0008 215.07 76.1783C213.457 74.6197 212.396 72.6356 210.457 71.4129C206.802 69.1108 198.57 74.1629 195.179 75.4304C194.405 75.717 190.033 78.1848 190.033 77.0965L194.194 52.7586C201.271 54.1874 206.166 50.3446 212.499 47.9574C222.231 44.2892 232.765 43.8055 242.453 40.536L243.515 40.1284C244.03 39.9313 243.998 39.9269 244.495 39.788C245.006 39.6447 244.8 39.7164 245.481 39.5506C245.512 39.5417 245.544 39.5327 245.575 39.5282L245.763 39.4745C245.794 39.4655 245.826 39.4566 245.857 39.4521C245.965 39.4252 246.077 39.3983 246.188 39.3715V39.367Z",
    fill: "url(#paint6_linear_743_1487)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M289.311 66.5533C296.692 76.5053 301.672 88.813 303.643 103.244C301.484 103.118 299.16 102.621 298.174 102.621C296.083 102.621 295.026 106.021 292.881 105.38C291.214 104.883 291.053 97.2824 289.477 97.6855C281.997 99.6069 286.27 105.564 284.03 107.216C281.639 108.977 277.393 109.196 274.571 109.666C266.8 110.961 260.037 110.146 253.995 104.323C252.383 102.765 251.326 100.78 249.382 99.5577C245.728 97.2556 237.496 102.308 234.101 103.575C233.33 103.862 228.959 106.33 228.959 105.241L233.12 80.9034C240.196 82.3322 245.092 78.4894 251.425 76.1022C261.157 72.434 271.691 71.9503 281.379 68.6808L282.44 68.2732C282.955 68.0761 282.924 68.0717 283.421 67.9328C283.932 67.794 283.726 67.8612 284.407 67.6954C284.532 67.6641 284.657 67.6238 284.783 67.5924C286.032 67.2879 287.699 66.8982 289.311 66.5533Z",
    fill: "url(#paint7_linear_743_1487)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M304.113 107.31C304.431 110.643 304.593 114.082 304.593 117.63C304.593 125.279 303.948 132.535 302.523 139.106C297.762 141.488 301.014 146.455 298.999 147.942C296.611 149.702 292.365 149.922 289.544 150.392C281.773 151.687 275.01 150.871 268.968 145.049C267.351 143.49 266.294 141.506 264.355 140.283C260.7 137.981 252.468 143.033 249.073 144.301C248.303 144.588 243.932 147.055 243.932 145.967L248.092 121.629C255.169 123.058 260.064 119.215 266.397 116.828C276.13 113.16 286.664 112.676 296.352 109.407L297.413 108.999C297.928 108.802 297.892 108.797 298.394 108.659C298.905 108.515 298.698 108.587 299.379 108.421C299.505 108.39 299.63 108.35 299.755 108.318C300.96 108.023 302.555 107.651 304.113 107.315V107.31Z",
    fill: "url(#paint8_linear_743_1487)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M297.059 154.298C292.427 162.682 285.454 168.603 275.569 170.811L275.56 170.847C275.56 170.847 271.574 172.983 266.101 173.382C260.628 173.78 261.47 176.069 253.838 176.669C250.215 176.956 247.702 178.246 245.082 179.473L247.192 167.138C254.268 168.567 259.163 164.724 265.496 162.337C275.229 158.669 285.768 158.185 295.455 154.916L296.512 154.508C296.803 154.396 296.92 154.347 297.059 154.298Z",
    fill: "url(#paint9_linear_743_1487)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M184.112 86.493C183.928 86.9812 188.443 86.0496 188.752 86.0048C190.517 85.7406 191.851 88.0695 193.656 87.8008C195.609 87.5052 196.76 85.7137 198.946 85.7137C200.007 85.7137 203.882 87.129 204.715 86.3766C205.61 85.5704 205.436 84.4552 206.887 83.958C208.772 83.3041 211.025 84.4372 212.915 83.7833C214.895 83.0981 217.578 82.9592 219.378 82.0635C220.296 81.6066 220.682 80.5183 221.761 80.3078C226.75 79.3269 237.181 82.686 238.292 88.6608C238.753 91.151 236.407 94.0711 235.95 96.5882C235.166 100.87 235.968 105.519 233.648 109.375C231.534 112.887 227.588 113.809 223.933 114.96C216.722 117.227 209.699 120.622 202.112 121.302C199.931 121.499 196.854 122.27 194.695 121.576C190.535 120.236 187.677 116.783 184.157 114.432C182.495 113.326 180.869 112.161 179.772 110.45C179.387 109.841 178.626 108.645 179.427 108.282",
    fill: "url(#paint10_linear_743_1487)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M184.112 109.505C183.928 109.993 188.443 109.062 188.752 109.017C190.517 108.753 191.851 111.082 193.656 110.813C195.609 110.517 196.76 108.726 198.946 108.726C200.007 108.726 203.882 110.141 204.715 109.389C205.61 108.582 205.436 107.467 206.887 106.97C208.772 106.316 211.025 107.449 212.915 106.795C214.895 106.11 217.578 105.971 219.378 105.076C220.296 104.619 220.682 103.53 221.761 103.32C226.75 102.339 237.181 105.698 238.292 111.673C238.753 114.163 236.407 117.083 235.95 119.6C235.166 123.882 235.968 128.531 233.648 132.387C231.534 135.899 227.588 136.821 223.933 137.972C216.722 140.239 209.699 143.634 202.112 144.314C199.931 144.511 196.854 145.282 194.695 144.588C190.535 143.248 187.677 139.795 184.157 137.444C182.495 136.338 180.869 135.173 179.772 133.462C179.387 132.853 178.626 131.657 179.427 131.294",
    fill: "url(#paint11_linear_743_1487)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M184.112 132.513C183.928 133.001 188.443 132.069 188.752 132.025C190.517 131.76 191.851 134.089 193.656 133.821C195.609 133.525 196.76 131.733 198.946 131.733C200.007 131.733 203.882 133.149 204.715 132.396C205.61 131.59 205.436 130.475 206.887 129.978C208.772 129.324 211.025 130.457 212.915 129.803C214.895 129.118 217.578 128.979 219.378 128.083C220.296 127.626 220.682 126.538 221.761 126.328C226.75 125.347 237.181 128.706 238.292 134.68C238.753 137.171 236.407 140.091 235.95 142.608C235.166 146.89 235.968 151.539 233.648 155.395C231.534 158.906 227.588 159.829 223.933 160.98C216.722 163.246 209.699 166.641 202.112 167.322C199.931 167.519 196.854 168.289 194.695 167.595C190.535 166.256 187.677 162.803 184.157 160.452C182.495 159.345 180.869 158.181 179.772 156.47C179.387 155.861 178.626 154.665 179.427 154.302",
    fill: "url(#paint12_linear_743_1487)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25293 96.4315L59.2254 112.089V140.436L95.123 149.967V123.331L111.09 127.971V99.4636L95.123 95.9298V20.8471L59.9509 11.5088L0.25293 66.8937V96.436V96.4315ZM59.2254 46.6227V84.6746L28.7426 76.5814L59.2254 46.6227Z",
    fill: "url(#paint13_linear_743_1487)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M208.177 152.721C193.827 148.91 190.378 133.305 190.378 111.521C190.378 99.6652 190.741 74.0957 207.814 78.6282C226.517 83.5952 225.792 107.472 225.792 120.568C225.792 141.466 221.618 156.286 208.177 152.717V152.721ZM152.671 99.3875C152.671 135.151 166.81 169.333 208.177 180.32C249.543 191.306 263.503 164.232 263.503 128.643C263.503 87.2275 241.383 59.9561 208.177 51.1373C178.966 43.38 152.85 53.6006 152.671 99.3875Z",
    fill: "url(#paint14_linear_743_1487)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M111.121 99.4547C111.121 99.4547 115.971 97.3586 120.898 99.0426C125.825 100.731 131.862 97.8871 135.817 93.4486C139.767 89.0101 152.178 88.4547 152.178 88.4547L136.108 85.024C136.108 85.024 132.444 85.4136 131.056 87.2992C129.672 89.1848 128.078 90.6896 124.571 90.4388C121.068 90.1835 119.124 88.1322 113.799 89.355C108.469 90.5777 95.0957 96.0149 95.0957 96.0149L111.121 99.4547Z",
    fill: "#F112F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8111 16.4848C79.7113 18.6257 80.4907 20.8382 81.2073 22.1012C82.5823 24.5108 86.3042 25.3931 87.1462 28.4208C88.2256 32.3084 86.3848 37.3739 88.5436 40.8719C90.147 43.4696 92.9104 44.7057 95.1543 46.4659V95.9119L111.121 99.4502V127.949L95.1543 123.322V140.001C91.6384 137.211 95.5753 132.974 93.2956 130.582C90.5814 127.734 89.4886 125.257 87.285 122.283C85.1128 119.354 81.5611 117.795 79.3889 114.517C75.7521 109.03 74.7533 101.721 73.3783 95.4014C72.0705 89.3908 73.8128 82.8831 72.4019 77.0383C71.2285 72.1832 64.4252 65.6263 62.0604 60.5294C61.0303 58.3124 60.1076 56.0461 59.2522 53.7485V46.6137L57.3979 48.4366C54.7465 40.3703 52.6146 32.0621 49.6227 24.2152C49.3361 23.4628 49.0315 22.6969 48.7314 21.9265L59.9777 11.4909L78.8111 16.4937V16.4848Z",
    fill: "url(#paint15_linear_743_1487)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2524 61.4117C61.7471 64.0318 65.4824 65.1604 67.2739 68.3807C69.0565 71.592 66.0557 75.7349 68.1115 78.8835C70.3016 82.2336 73.8578 82.6233 76.4286 85.2658C79.4876 88.4144 80.1819 93.6546 83.1379 97.0899C86.6089 101.125 91.567 103.575 94.6663 107.906C97.3088 111.597 100.001 118.221 101.864 125.266L95.159 123.322V149.949L59.2569 140.413V112.067L42.4479 107.602C42.5151 103.701 42.8689 99.7771 41.9821 96.1135C40.8087 91.2584 34.0053 84.7015 31.6405 79.6046C31.2419 78.7491 30.8612 77.8847 30.494 77.0158L59.2569 84.6522V61.4072L59.2524 61.4117ZM42.4613 27.7355C43.4556 28.8597 44.7769 29.8271 45.6816 30.7766C47.8673 33.0698 49.4304 38.8116 50.783 41.1854C52.1579 43.595 55.8798 44.4773 56.7219 47.505C56.8428 47.9349 56.9234 48.3783 56.9816 48.8352L29.858 75.4931C26.2525 66.5444 23.9236 56.9642 20.8242 47.8185L42.4658 27.74L42.4613 27.7355Z",
    fill: "url(#paint16_linear_743_1487)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2522 121.988C61.0885 123.488 62.8486 125.051 64.2416 126.99C66.79 130.551 69.3832 136.835 71.233 143.598L59.2522 140.418V121.992V121.988ZM16.5826 51.7464C18.1054 54.4651 19.2967 58.4019 20.3582 60.2651C21.7332 62.6747 25.4551 63.557 26.2971 66.5847C27.3765 70.4723 25.5357 75.5378 27.6945 79.0358C30.0145 82.7935 34.7576 83.7027 36.8492 87.4604C38.6317 90.6717 35.6309 94.8146 37.6867 97.9632C39.8768 101.313 43.433 101.703 46.0038 104.346C47.343 105.725 48.2298 107.499 49.0494 109.353L0.28418 96.4046V66.8714L16.587 51.7464H16.5826Z",
    fill: "url(#paint17_linear_743_1487)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M225.81 114.705C230.137 119.26 236.362 121.786 241.307 125.678C250.103 132.602 256.857 138.635 261.959 147.647C261.148 152.085 260.002 156.241 258.483 160.031C257.431 159.009 256.338 158.154 255.079 157.697C251.384 156.367 251.075 161.477 249.306 162.669C248.504 163.211 245.992 161.24 244.688 161.406C242.086 161.741 239.82 163.582 236.936 162.628C233.671 161.549 228.614 154.548 226.957 151.274C225.927 149.232 226.908 145.461 226.876 145.448C225.743 144.937 223.88 145.38 222.124 145.64C224.794 139.768 225.819 130.905 225.819 120.55C225.819 118.772 225.833 116.797 225.81 114.696V114.705ZM165.311 58.8274C167.792 64.6543 171.447 71.3905 177.067 72.1698C179.32 72.4833 181.869 71.7398 184.077 72.2817C189.183 73.5358 192.667 77.8937 195.901 82.274C190.58 89.3147 190.414 103.521 190.414 111.512C190.414 116.698 190.611 121.535 191.104 125.942C189.384 123.3 187.723 121.168 185.976 120.559C183.804 119.797 179.284 122.839 176.902 123.121C172.275 123.663 170.69 120.25 166.842 119.82C164.195 119.524 161.978 121.41 159.26 120.675C158.203 120.389 156.953 119.453 156.125 118.785C155.296 118.113 154.539 117.325 153.854 116.443C153.066 110.858 152.698 105.138 152.698 99.383C152.774 79.8554 157.567 66.7952 165.311 58.8408V58.8274Z",
    fill: "url(#paint18_linear_743_1487)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M152.707 100.874C154.951 104.713 157.849 107.951 161.642 108.475C163.895 108.789 166.444 108.045 168.652 108.587C176.928 110.62 180.937 120.81 186.544 126.027C188.018 127.398 189.742 128.294 191.516 129.082C193.41 141.493 198.113 150.025 208.208 152.703C209.87 153.147 211.388 153.303 212.777 153.205C216.821 156.479 221.788 158.763 225.882 161.983C232.819 167.447 238.49 172.356 243.08 178.613C234.642 183.249 223.235 184.279 208.208 180.288C206.171 179.746 204.195 179.151 202.287 178.497C202.346 176.365 202.749 173.879 202.05 173.485C199.04 171.792 195.636 173.203 192.712 174.524C186.388 171.389 180.937 167.564 176.275 163.179C174.335 160.116 172.499 157.545 170.551 156.86C170.483 156.837 170.412 156.815 170.34 156.801C157.97 141.587 152.935 121.544 152.707 100.87V100.874Z",
    fill: "url(#paint19_linear_743_1487)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M162.479 62.1462C172.723 48.4679 189.854 46.2464 208.208 51.1194C211.46 51.9838 214.604 53.0229 217.632 54.2366C221.461 58.2093 224.399 63.6063 228 66.952C231.897 70.5753 237.576 70.8888 241.195 74.6331C243.197 76.7068 243.376 79.8912 244.576 82.3904C246.076 85.5121 248.979 88.6876 251.254 91.2943C253.31 93.6501 255.872 95.4685 258.545 97.1615C261.793 106.468 263.539 116.989 263.539 128.63C263.539 132.495 263.374 136.261 263.029 139.889L262.966 139.867C259.701 138.792 254.64 131.787 252.987 128.513C251.953 126.471 252.933 122.7 252.902 122.686C250.739 121.714 245.906 124.218 244.245 122.279C242.982 120.801 244.603 115.032 243.501 114.414C238.221 111.444 231.722 118.028 228.743 116.935C227.709 116.559 226.737 115.941 225.814 115.153C225.693 101.739 224.189 82.9503 207.845 78.6103C196.317 75.5468 192.411 86.2243 191.09 97.1302C189.169 97.4795 187.377 98.4649 185.286 97.9005C184.233 97.6139 182.979 96.6778 182.15 96.006C176.126 91.1241 173.842 79.8599 174.236 72.4072C174.312 70.9202 175.661 68.8196 174.975 67.2879C174.438 66.0786 166.076 64.7708 162.479 62.1507V62.1462Z",
    fill: "url(#paint20_linear_743_1487)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M341.628 165.898L400.6 181.556V209.902L436.498 220.217V192.802L452.465 197.442V168.934L436.498 165.401V90.3179L401.326 80.9796L341.628 136.364V165.907V165.898ZM400.6 116.089V154.141L370.118 146.048L400.6 116.089Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.02,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M360.434 91.9123C360.434 91.9123 363.448 89.14 368.115 89.8521C372.782 90.5687 377.005 84.7866 382.407 85.4315C387.808 86.0765 389.093 81.8216 394.253 82.256C399.413 82.6905 401.486 80.9079 401.486 80.9079L436.506 90.291L429.134 102.67L405.002 104.829L399.878 103.454L403.874 100.745L395.359 101.313L360.434 91.9034V91.9123Z",
    fill: "url(#paint21_linear_743_1487)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M332.751 152.287C332.751 152.287 325.876 154.168 326.803 157.021C327.73 159.874 324.429 162.87 332.751 164.084C341.072 165.298 343.692 167.076 350.406 166.65C357.12 166.225 360.461 168.482 362.714 165.248C364.967 162.015 367.623 161.8 366.83 154.952C366.037 148.103 366.476 145.506 364.259 143.844C362.042 142.182 361.33 141.972 361.33 141.972",
    fill: "url(#paint22_linear_743_1487)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M329.078 157.066C329.078 157.066 330.923 155.502 333.852 155.785C336.786 156.067 338.501 157.294 341.628 154.266C344.758 151.239 348.243 150.75 351.159 151.149C354.074 151.543 362.064 149.196 363.323 145.04C364.582 140.884 365.589 125.647 364.187 125.051C362.786 124.455 351.983 121.49 345.923 125.571C339.859 129.651 324.335 142.998 321.271 146.03",
    fill: "url(#paint23_linear_743_1487)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M395.359 101.466C395.359 101.466 401.348 98.8187 405.938 99.701C410.529 100.583 413.57 99.2934 415.935 97.5243C418.295 95.7552 423.621 92.5304 427.902 93.4083C432.184 94.2861 436.506 90.3 436.506 90.3V169.306L395.359 176.71V101.47V101.466Z",
    fill: "url(#paint24_linear_743_1487)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M395.359 230.446C395.359 230.446 401.11 231.799 404.339 228.825C407.573 225.851 408.988 224.749 413.615 224.897C418.242 225.045 419.63 225.381 424.31 223.473C428.991 221.565 431.221 220.176 432.896 220.387C434.567 220.597 436.506 220.203 436.506 220.203V197.236L395.359 203.762V230.442V230.446Z",
    fill: "url(#paint25_linear_743_1487)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M411.421 208.075C411.421 208.075 415.506 205.943 418.771 206.104C422.036 206.27 422.918 207.967 426.77 206.771C430.621 205.58 430.205 201.639 436.184 201.437C442.163 201.236 446.167 202.494 448.21 201.025C450.252 199.56 452.478 197.42 452.478 197.42V168.921L439.203 168.576L411.421 177.95V208.07V208.075Z",
    fill: "#A807AA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M300.557 176.871L359.529 192.529V220.875L395.427 230.406V203.771L411.394 208.411V179.903L395.427 176.369V101.286L360.255 91.9482L300.557 147.333V176.875V176.871ZM359.529 127.062V165.114L329.046 157.021L359.529 127.062Z",
    fill: "url(#paint26_linear_743_1487)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M411.421 179.925C411.421 179.925 416.271 177.829 421.198 179.513C426.125 181.202 432.162 178.358 436.117 173.919C440.067 169.481 452.478 168.925 452.478 168.925L436.408 165.495C436.408 165.495 432.744 165.884 431.356 167.77C429.972 169.655 428.377 171.16 424.871 170.91C421.368 170.654 419.424 168.603 414.099 169.826C408.769 171.048 395.396 176.486 395.396 176.486L411.421 179.925Z",
    fill: "#F112F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M379.106 96.9555C380.006 99.0964 380.786 101.309 381.502 102.572C382.877 104.982 386.599 105.864 387.441 108.892C388.52 112.779 386.68 117.845 388.838 121.343C390.442 123.94 393.205 125.176 395.449 126.937V176.383L411.416 179.921V208.42L395.449 203.793V220.472C391.933 217.682 395.87 213.445 393.59 211.053C390.876 208.205 389.783 205.728 387.58 202.754C385.408 199.825 381.856 198.266 379.684 194.988C376.047 189.501 375.048 182.192 373.673 175.872C372.365 169.862 374.108 163.354 372.697 157.509C371.523 152.654 364.72 146.097 362.355 141C361.325 138.783 360.403 136.517 359.547 134.219V127.084L357.693 128.907C355.041 120.841 352.909 112.533 349.918 104.686C349.631 103.933 349.326 103.168 349.026 102.397L360.273 91.9616L379.106 96.9644V96.9555Z",
    fill: "url(#paint27_linear_743_1487)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M359.548 141.887C362.042 144.507 365.778 145.636 367.569 148.856C369.352 152.067 366.351 156.21 368.407 159.359C370.597 162.709 374.153 163.099 376.724 165.741C379.783 168.89 380.477 174.13 383.433 177.565C386.904 181.6 391.862 184.05 394.962 188.381C397.604 192.072 400.296 198.696 402.159 205.741L395.454 203.797V230.424L359.552 220.889V192.542L342.743 188.077C342.81 184.176 343.164 180.252 342.277 176.589C341.104 171.734 334.301 165.177 331.936 160.08C331.537 159.224 331.157 158.36 330.789 157.491L359.552 165.127V141.882L359.548 141.887ZM342.761 108.211C343.755 109.335 345.077 110.302 345.981 111.252C348.167 113.545 349.73 119.287 351.083 121.661C352.458 124.07 356.18 124.953 357.022 127.98C357.143 128.41 357.223 128.854 357.281 129.31L330.158 155.968C326.552 147.02 324.223 137.439 321.124 128.294L342.766 108.215L342.761 108.211Z",
    fill: "url(#paint28_linear_743_1487)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M359.547 202.463C361.384 203.963 363.144 205.526 364.537 207.466C367.085 211.026 369.679 217.31 371.528 224.073L359.547 220.893V202.467V202.463ZM316.882 132.222C318.405 134.94 319.597 138.877 320.658 140.74C322.033 143.15 325.755 144.032 326.597 147.06C327.676 150.948 325.836 156.013 327.994 159.511C330.314 163.269 335.057 164.178 337.149 167.936C338.932 171.147 335.931 175.29 337.986 178.438C340.177 181.789 343.733 182.178 346.304 184.821C347.643 186.2 348.53 187.974 349.349 189.828L300.584 176.88V147.347L316.887 132.222H316.882Z",
    fill: "url(#paint29_linear_743_1487)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_743_1487",
    x1: 150.681,
    y1: 14.9213,
    x2: 60.6494,
    y2: 16.3199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F442F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_743_1487",
    x1: 54.228,
    y1: 109.24,
    x2: 45.8941,
    y2: 77.8744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A807AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25005B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_743_1487",
    x1: 20521.1,
    y1: 3411.5,
    x2: 20468.5,
    y2: 3402.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A807AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25005B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_743_1487",
    x1: 132.454,
    y1: 61.6668,
    x2: 82.8101,
    y2: 39.5432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A807AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25005B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_743_1487",
    x1: 112.516,
    y1: 143.547,
    x2: 114.685,
    y2: 120.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A807AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F005B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_743_1487",
    x1: 317.463,
    y1: 90.5924,
    x2: 228.179,
    y2: 109.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92FFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#29637C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_743_1487",
    x1: -873.724,
    y1: -2209.04,
    x2: -842.849,
    y2: -2145.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001331",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_743_1487",
    x1: 1974.72,
    y1: 4096.64,
    x2: 2002.54,
    y2: 4161.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001331",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_743_1487",
    x1: 4529.89,
    y1: 12354.3,
    x2: 4552.5,
    y2: 12419.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001331",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_743_1487",
    x1: -1458.09,
    y1: -3184.21,
    x2: -1438.72,
    y2: -3146.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001331",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_743_1487",
    x1: 209.525,
    y1: 73.1692,
    x2: 211.176,
    y2: 111.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001331",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_743_1487",
    x1: 209.525,
    y1: 96.1768,
    x2: 211.176,
    y2: 134.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001331",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_743_1487",
    x1: 209.525,
    y1: 119.189,
    x2: 211.176,
    y2: 157.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001331",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_743_1487",
    x1: 94.0763,
    y1: 106.166,
    x2: 6.51167,
    y2: 10.5394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F442F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FFFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_743_1487",
    x1: 174.462,
    y1: 74.4098,
    x2: 275.782,
    y2: 219.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92FFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_743_1487",
    x1: 8250.9,
    y1: -4503.44,
    x2: 8202.11,
    y2: -4476.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46026F",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46026F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_743_1487",
    x1: -5622.05,
    y1: 2419.89,
    x2: -5685.43,
    y2: 2445.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46026F",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46026F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_743_1487",
    x1: -9998.47,
    y1: 3634.25,
    x2: -10054,
    y2: 3653.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46026F",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46026F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_743_1487",
    x1: 3165.76,
    y1: -3839.4,
    x2: 3131.7,
    y2: -3793.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#265F7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#265F7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_743_1487",
    x1: 1249.81,
    y1: -1200.7,
    x2: 1221.64,
    y2: -1164.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#265F7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#265F7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_743_1487",
    x1: 1245.75,
    y1: -1206.07,
    x2: 1214.25,
    y2: -1166.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#265F7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#265F7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_743_1487",
    x1: 450.979,
    y1: 95.3965,
    x2: 360.948,
    y2: 96.7951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F442F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_743_1487",
    x1: 354.527,
    y1: 189.71,
    x2: 346.194,
    y2: 158.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A807AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25005B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_743_1487",
    x1: 20821.4,
    y1: 3491.97,
    x2: 20768.8,
    y2: 3483.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A807AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25005B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_743_1487",
    x1: 432.748,
    y1: 142.138,
    x2: 383.104,
    y2: 120.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A807AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25005B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_743_1487",
    x1: 412.81,
    y1: 224.017,
    x2: 414.98,
    y2: 201.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A807AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F005B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_743_1487",
    x1: 394.38,
    y1: 186.606,
    x2: 306.815,
    y2: 90.9788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F442F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FFFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_743_1487",
    x1: 8551.2,
    y1: -4422.97,
    x2: 8502.41,
    y2: -4395.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46026F",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46026F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_743_1487",
    x1: -5321.75,
    y1: 2500.36,
    x2: -5385.13,
    y2: 2526.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46026F",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46026F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_743_1487",
    x1: -9698.18,
    y1: 3714.72,
    x2: -9753.66,
    y2: 3734.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46026F",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46026F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.a3b9fbabdd0a90a48dae497c8545a06d.svg";
export { ForwardRef as ReactComponent };